const identity = {
  logo: {
    height: 40,
    width: 100,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
  develop: {
    navText: '#A2C3B7',
    // backgroundGradient: 'linear-gradient(110deg, #64CDB4 0%, #53ABAF 55%, #4FA0AA 56%, #313C5E 100%)',
    backgroundGradient:
      'linear-gradient(to right top, #41495e, #4b677c, #578796, #6ca7a8, #8fc7b5)',
    from: '#41495e',
    to: '#8fc7b5',
    offset: '#ffffff',
  },
  devops: {
    navText: '#C45A5E',
    // backgroundGradient: 'linear-gradient(110deg, #FDBCDD 0%, #E24E74 55%, #DA3F68 56%, #D60424 100%)',
    backgroundGradient:
      'linear-gradient(to right top, #ea3b4c, #e3475b, #db5268, #d15c73, #c6667c)',
    from: '#ea3b4c',
    to: '#c6667c',
    offset: '#ffffff',
  },
  dynamics_365: {
    navText: '#7760E3',
    // backgroundGradient: 'linear-gradient(110deg, #50047F 0%, #7B2AAE 55%, #7126A2 56%, #912D99 100%)',
    backgroundGradient:
      'linear-gradient(to right top, #3e2772, #4f3291, #613eb1, #734ad3, #8656f5)',
    from: '#3e2772',
    to: '#8656f5',
    offset: '#ffffff',
  },
  datascience: {
    navText: '#38CCF1',
    // backgroundGradient: 'linear-gradient(110deg, #50047F 0%, #7B2AAE 55%, #7126A2 56%, #912D99 100%)',
    backgroundGradient:
    'linear-gradient(to right top, #1659cb, #007ce0, #009beb, #00b8f0, #4ed4f2)',
    from: '#7FDFF7',
    to: '#145DCD',
    offset: '#ffffff',
  },
  taas: {
    navText: '#C4BE5A',
  },
  fixed: {
    navText: '#E38E60',
  },





  studies: {
    backgroundGradient:
      // ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
      'linear-gradient(to right top, #b8557b, #ba398b, #ae1da6, #8c17c9, #072ff0)',
    offset: '#ffffff',
  },
  blog: {
    backgroundGradient:
      ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
    offset: '#ffffff',
  },
  careers: {
    backgroundGradient:
      ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
    offset: '#ffffff',
  },
  about: {
    backgroundGradient:
      ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
    offset: '#ffffff',
  },
  contact: {
    backgroundGradient:
      ' linear-gradient(to right top, #8fcf68, #00c19a, #00a9e4, #0083ff, #7633d9)',
    offset: '#ffffff',
  },
}

export default identity



// WEBPACK FOOTER //
// ./src/themes/default/brand/identity.js